import { geoMercator, geoPath, select } from 'd3'
import * as topojson from 'topojson'
import { drawLineChart } from './drawLineChart'
import _ from 'underscore'

export const projection = geoMercator()
    .center([-73.9967, 40.7082])
    .scale(150000)

export const circle = props => {
    const { classSelector }= props
    const lines = ['1','2','3','A','B','C','D','E','F','G','J','L','M','N','Q','R','W','Z','4','5','6','7']
    const chart = selection => {
        const g = selection.select('svg').select(classSelector)
        g.selectAll('.point')
            .data(lines)
            .enter().append('circle')
            .attr('r', 3 )
            .attr('cx', 616.9774511869764)
            .attr('cy', 852.8658360008121)
            .attr('id', d => `circle-${d}`)
            .attr('class', 'point')
            .style('fill', 'crimson')
            .style('opacity', .5)
    }
    return chart
}
export const translateAlong  = (routePath, filter, projection, tick, track) => {
    const
        round = (x, n) => n == null ? Math.round(x) : Math.round(x * (n = Math.pow(10, n))) / n,
        station = (x, y) => _.filter(filter, e => {
            let coord = projection(e.geometry.coordinates)
            return round(coord[1], 0) === round(y, 0) && round(coord[0],0) === round(x,0)
        })
    ;
    if(!routePath) return
    let
        node = routePath.node(),
        l = node.getTotalLength()
    return function(d, i, a) {
        return function(t) {
            var p = node.getPointAtLength(t * l)
            var addy = (p.y) -852.8658360008121
            var addx = (p.x) -616.9774511869764
            var stat = station(p.x, p.y)
            if (stat[0]){
                if (stat[0].properties.name === '8th Ave'
                || stat[0].properties.name === 'Rector St'
                || stat[0].properties.name === 'Brooklyn Bridge - City Hall') {
                    select(a[i]).interrupt()
                }
                stat[0].properties['ts'] = Date.now()
                tick(stat[0], track)
            }
            return 'translate(' + addx + ',' + addy + ')'
        }
    }
}

export const drawSubwayLogos = props => {
    const { data, onClick } = props
    const chart = selection => {
        const g = selection.select('svg g')
        const circle = g.selectAll('g.circle').data(data)
        const text = g.selectAll('text').data(data)
        // circle.exit().remove()
        const group = circle.enter().append('g').attr('class', d => `g${d}`)
        group
            .append('circle')
            .attr('class', d =>`c${d}` )
            .attr('cx', 81 )
            .attr('cy', 35 )
            .attr('r', 20 )
            // .style('opacity', .75)
            .attr('transform', (d,i) => `translate(${i * 50},-10)`)
        // text.exit().remove()
        group.append('text')
            .attr('class', d => `t${d} subway-label `)
            .attr('x', 72 )
            .attr('y', 45 )
            .attr('transform', (d,i) => `translate(${i * 50},-10)`)
            .text(d => d )

        group.on('click', onClick )
    }
    return chart
}

export const drawSubwaySystem = props => {
    const { data } = props
    const [a, b, c, d, e] = data
    const chart = selection => {
        selection
            .call(drawBoroughsBackground({...props, classSelector: 'g.g-boroughs-background', data: a }))
            .call(drawSubwayPaths({ ...props, classSelector: 'g.g-phantom-paths',  data: b }))
            .call(drawSubwayPaths({ ...props, classSelector: 'g.g-subway-paths', data: c }))
            .call(drawSubwayStations({ ...props, classSelector: 'g.g-subway-stations', stations: d }))
            .call(drawLineChart({ ...props, classSelector: 'g.g-income-graph', data: e}))
            .call(circle({ classSelector: 'g.g-point'}))
    }
    return chart
}

export const drawSubwayPaths = props => {
    const { data, width, height, classSelector } = props
    const { routes, pathClass, geographyKey } = data
    const path = geoPath().projection(projection.translate([(width) / 2, (height)/2]))
    const chart = selection => {
        const g = selection.select('svg').select(classSelector)
        g.selectAll('.routes')
            .data(routes[geographyKey])
            .join('path')
            .attr('class', pathClass )
            .attr('d', d => {
                let array = [];
                if(d.geometry.type==='LineString') {
                    array.push(d.geometry.coordinates);
                }
                if(d.geometry.type==='MultiLineString') {
                    d.geometry.coordinates.forEach( each => {
                        array.push(each);
                    });
                }
                return path({
                    type: 'MultiLineString',
                    coordinates: array
                });
            })
            .style('stroke-opacity', 1)
            .style('stroke-width', 2)
    }
    return chart
}

export const drawBoroughsBackground = props => {
    const { data, width, height, classSelector } = props
    const path = geoPath().projection(projection.translate([(width) / 2, (height)/2]))
    const chart = selection => {
        const g = selection.select(classSelector)
        g.selectAll('path.borough_overlay')
            .data(topojson.feature(data, data.objects.nyc).features)
            .enter()
            .append('path')
            .attr('d', path )
            .attr('class','borough_map')
    }
    return chart
}

export const drawSubwayStations = props => {
    const { stations, classSelector } = props
    const chart = selection => {
        const g = selection.select('svg').select(classSelector)
        g.selectAll('.stations')
            .data(stations.features)
            .enter()
            .append('circle')
            .attr('r', 3 )
            .attr('cx', d => projection(d.geometry.coordinates)[0] )
            .attr('cy', d => projection(d.geometry.coordinates)[1] )
            .attr('fill', 'rgba(255,255,255,0)')
            .attr('stroke', 'grey')
        ;
        g.selectAll('.income')
            .data(stations.features)
            .enter()
            .append('text')
            .attr('dx', d => projection(d.geometry.coordinates)[0] + 4 )
            .attr('dy', d => projection(d.geometry.coordinates)[1] + 4 )
            // .text(d =>  d.properties.line.includes(track) ?  d.properties.name :null) //d.properties.name  : null)
            .style('fill','black')
            .style('font-size','8px');
    }
    return chart
}
